const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const getAuthHeaders = () => ({
  'Content-Type': 'application/json',
  'Authorization': `Bearer ${sessionStorage.getItem('token')}`
});

const adminApi = {
  // Kunder
  getClients: async () => {
    const response = await fetch(`${API_BASE_URL}/admin/clients`, {
      headers: getAuthHeaders(),
      credentials: 'include'
    });
    if (!response.ok) {
      throw new Error('Fejl ved hentning af kunder');
    }
    return response.json();
  },

  getClientLogs: async (clientId) => {
    const response = await fetch(`${API_BASE_URL}/admin/clients/${clientId}/logs`, {
      headers: getAuthHeaders(),
      credentials: 'include'
    });
    if (!response.ok) {
      throw new Error('Fejl ved hentning af logs');
    }
    return response.json();
  },

  createClient: async (clientData) => {
    const response = await fetch(`${API_BASE_URL}/admin/clients`, {
      method: 'POST',
      headers: getAuthHeaders(),
      credentials: 'include',
      body: JSON.stringify({
        ...clientData,
        payrollSystem: clientData.payrollSystem || null
      })
    });
    if (!response.ok) {
      throw new Error('Fejl ved oprettelse af kunde');
    }
    return response.json();
  },

  updateClient: async (clientId, clientData) => {
    const response = await fetch(`${API_BASE_URL}/admin/clients/${clientId}`, {
      method: 'PUT',
      headers: getAuthHeaders(),
      credentials: 'include',
      body: JSON.stringify({
        ...clientData,
        payrollSystem: clientData.payrollSystem || null
      })
    });
    if (!response.ok) {
      throw new Error('Fejl ved opdatering af kunde');
    }
    return response.json();
  },

  deleteClient: async (clientId) => {
    const response = await fetch(`${API_BASE_URL}/admin/clients/${clientId}`, {
      method: 'DELETE',
      headers: getAuthHeaders(),
      credentials: 'include'
    });
    if (!response.ok) {
      throw new Error('Fejl ved deaktivering af kunde');
    }
    return response.json();
  },

  activateClient: async (clientId) => {
    const response = await fetch(`${API_BASE_URL}/admin/clients/${clientId}/activate`, {
      method: 'POST',
      headers: getAuthHeaders(),
      credentials: 'include'
    });
    if (!response.ok) {
      throw new Error('Fejl ved aktivering af kunde');
    }
    return response.json();
  },

  getClient: async (clientId) => {
    const response = await fetch(`${API_BASE_URL}/admin/clients/${clientId}`, {
      headers: getAuthHeaders(),
      credentials: 'include'
    });
    if (!response.ok) {
      throw new Error('Fejl ved hentning af kunde');
    }
    return response.json();
  },

  // Brugere
  getClientUsers: async (clientId) => {
    const response = await fetch(`${API_BASE_URL}/admin/clients/${clientId}/users`, {
      headers: getAuthHeaders(),
      credentials: 'include'
    });
    if (!response.ok) {
      throw new Error('Fejl ved hentning af brugere');
    }
    return response.json();
  },

  createClientUser: async (clientId, userData) => {
    const response = await fetch(`${API_BASE_URL}/admin/clients/${clientId}/users`, {
      method: 'POST',
      headers: getAuthHeaders(),
      credentials: 'include',
      body: JSON.stringify(userData)
    });
    if (!response.ok) {
      throw new Error('Fejl ved oprettelse af bruger');
    }
    return response.json();
  },

  deleteClientUser: async (clientId, userId) => {
    const response = await fetch(`${API_BASE_URL}/admin/clients/${clientId}/users/${userId}`, {
      method: 'DELETE',
      headers: getAuthHeaders(),
      credentials: 'include'
    });
    if (!response.ok) {
      throw new Error('Fejl ved sletning af bruger');
    }
    return response.json();
  },

  activateClientUser: async (clientId, userId) => {
    const response = await fetch(`${API_BASE_URL}/admin/clients/${clientId}/users/${userId}/activate`, {
      method: 'POST',
      headers: getAuthHeaders(),
      credentials: 'include'
    });
    if (!response.ok) {
      throw new Error('Fejl ved aktivering af bruger');
    }
    return response.json();
  },

  // Konsulenter
  getConsultants: async () => {
    const response = await fetch(`${API_BASE_URL}/admin/consultants`, {
      headers: getAuthHeaders(),
      credentials: 'include'
    });
    if (!response.ok) {
      throw new Error('Fejl ved hentning af konsulenter');
    }
    return response.json();
  },

  createConsultant: async (consultantData) => {
    const response = await fetch(`${API_BASE_URL}/admin/consultants`, {
      method: 'POST',
      headers: getAuthHeaders(),
      credentials: 'include',
      body: JSON.stringify(consultantData)
    });
    if (!response.ok) {
      throw new Error('Fejl ved oprettelse af konsulent');
    }
    return response.json();
  },

  deleteConsultant: async (consultantId) => {
    const response = await fetch(`${API_BASE_URL}/admin/consultants/${consultantId}`, {
      method: 'DELETE',
      headers: getAuthHeaders(),
      credentials: 'include'
    });
    if (!response.ok) {
      throw new Error('Fejl ved deaktivering af konsulent');
    }
    return response.json();
  },

  activateConsultant: async (consultantId) => {
    const response = await fetch(`${API_BASE_URL}/admin/consultants/${consultantId}/activate`, {
      method: 'POST',
      headers: getAuthHeaders(),
      credentials: 'include'
    });
    if (!response.ok) {
      throw new Error('Fejl ved aktivering af konsulent');
    }
    return response.json();
  },

  resetPassword: async (email, newPassword, adminId) => {
    const response = await fetch(`${API_BASE_URL}/admin/reset-password`, {
      method: 'POST',
      headers: getAuthHeaders(),
      credentials: 'include',
      body: JSON.stringify({ email, newPassword, adminId })
    });
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || 'Fejl ved nulstilling af adgangskode');
    }
    return response.json();
  },

  getMigrationLogs: async () => {
    const response = await fetch(`${API_BASE_URL}/admin/migration-logs`, {
      headers: getAuthHeaders(),
      credentials: 'include'
    });
    if (!response.ok) {
      throw new Error('Fejl ved hentning af migration logs');
    }
    return response.json();
  },

  runMigrations: async () => {
    const response = await fetch(`${API_BASE_URL}/admin/run-migrations`, {
      method: 'POST',
      headers: getAuthHeaders(),
      credentials: 'include'
    });
    if (!response.ok) {
      throw new Error('Fejl ved kørsel af migrationer');
    }
    return response.json();
  }
};

export default adminApi; 